import { useTranslation } from 'react-i18next';
import { KoobButton, KoobTooltip } from '@koob/ui';
import { useTripFilters } from '@koob/trip-designer';
import {
  FolderAddServiceMenu,
  FolderArchiveButton,
  FolderReadOnlyTooltip,
} from '@koob/booking';
import { canCancelAllFolderBookings } from '@koob/utils';
import CancelAllBookings from './CancelAllBookings';

/**
 * TO actions of a client folder (KD-3842), for its page header, assembled
 * from the shared folder bricks. An archived folder is read-only.
 */
export default function FoldersDetailsActions({
  folder,
  canDesignTrip,
  onEditDetails,
  onArchive,
  onUnarchive,
  onAddHotel,
  onAddExperience,
  onDesignTrip,
  reload,
}) {
  const { t } = useTranslation('folders');
  const archived = Boolean(folder.archivedAt);
  const tripOpen = Object.keys(useTripFilters() ?? {}).length > 1;

  return (
    <>
      <FolderReadOnlyTooltip readOnly={archived}>
        <KoobButton
          variant="secondary"
          onClick={onEditDetails}
          disabled={archived}
          data-testid="folder-edit-details"
        >
          {t('actions.editDetails')}
        </KoobButton>
      </FolderReadOnlyTooltip>

      <FolderArchiveButton
        folder={folder}
        onArchive={onArchive}
        onUnarchive={onUnarchive}
      />

      {canCancelAllFolderBookings(folder) && (
        <CancelAllBookings
          folderId={folder.id}
          bookings={folder.bookings ?? []}
          reload={reload}
        />
      )}

      <span className="mx-1 h-[26px] w-px bg-gray-200" aria-hidden="true" />

      <FolderReadOnlyTooltip readOnly={archived}>
        <FolderAddServiceMenu
          onAddHotel={onAddHotel}
          onAddExperience={onAddExperience}
          disabled={archived}
        />
      </FolderReadOnlyTooltip>

      {canDesignTrip && (
        <FolderReadOnlyTooltip readOnly={archived}>
          <KoobTooltip
            tip={t('tripDesigner:compose.tripAlreadyOpen')}
            disabled={archived || !tripOpen}
          >
            <span className="inline-flex">
              <KoobButton
                variant="primary"
                onClick={onDesignTrip}
                disabled={archived || tripOpen}
                data-testid="folder-design-trip"
              >
                {t('actions.designTrip')}
              </KoobButton>
            </span>
          </KoobTooltip>
        </FolderReadOnlyTooltip>
      )}
    </>
  );
}
